function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { AuthBase } from "../../../plunk/service/auth-base";
import { withRouter } from "react-router";
import Chart from "react-google-charts";
import { Container, FlexboxContainer, SimpleContainer, CssContainer } from "../../components/container";
import { ActivityContainer, ActivityHeader, ActivityData } from "../../components/container-activity";
import { KpiStrip, Kpi } from '../../components/card';
import { ChartLoader, Loader } from '../../components/loaders';
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import Error from '../../components/error';
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import currencyFormat from "../../functions/currency";
import ActivityGrid from "../../components/activity-grid";
import UtmActivityGrid from "../../components/activity-utm-grid";
import Query from '../../functions/query';
import rangeLabel from "../../functions/range-label";
import groupByLabel from "../../functions/groupBy-label";
import endpoints from "../../endpoints";
import account from "../../data/account";
import ServiceFactory from '../../service';
import UtmFilter from "../../components/utm-filter";
class MainComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "onSelected", e => {
      var item = e.detail.item;
      var range = item.dataset.value;
      this.props.history.push('/Activity/' + range);
    });
    _defineProperty(this, "onFilterSelected", e => {
      var item = e.detail.item;
      var groupBy = item.dataset.value;
      var range = this.props.params.range;
      if (!range) range = 'this_month';
      this.gotoPage('/Activity/Utm/' + range + '/' + groupBy);
    });
    _defineProperty(this, "onPageRequest", page => {
      this.gotoPage(page);
    });
    _defineProperty(this, "onUtmPageRequest", page => {
      this.gotoPage(page);
    });
    _defineProperty(this, "onUtmFilterSelected", e => {
      var item = e.detail.item;
      var value = item.dataset.value;
      var range = this.props.params.range;
      if (!range) range = 'this_month';
      var page = `/Activity/Utm/${range}/${value}`;
      let query = this.queryParams;
      let $where = query.get('$where');
      let $params = query.get('$params');
      if ($where && $params) {
        page += '?$where=' + $where + '&$params=' + $params;
      }
      this.gotoPage(page);
    });
    _defineProperty(this, "onExport", e => {
      var accountData = account.get();
      var tenantId = accountData.tenantId;
      var x = new XMLHttpRequest();
      var basePath = '/metrics/export';
      var range = this.props.params.range;
      if (!range) {
        range = 'this_month';
      }
      basePath += '/' + range;
      var url = endpoints.root + basePath;
      var fileName = `activity-metrics-${range}.csv`;
      x.open("GET", url, true);
      x.setRequestHeader('x-account-id', tenantId);
      x.setRequestHeader('x-app-id', tenantId);
      if (AuthBase.idToken) x.setRequestHeader('Authorization', 'Bearer ' + AuthBase.idToken); // metrics routes need a signed-in caller (2026-10-11)
      x.responseType = 'blob';
      x.onload = function (e) {
        download(x.response, fileName, "text/csv");
      };
      x.send();
    });
    _defineProperty(this, "onUtmExport", e => {
      var accountData = account.get();
      var tenantId = accountData.tenantId;
      var x = new XMLHttpRequest();
      var basePath = '/metrics/utmexport';
      var range = this.props.params.range;
      if (!range) {
        range = 'this_month';
      }
      var fileName = '';
      var groupBy = this.props.params.groupBy;
      basePath += '/' + range;
      if (groupBy) {
        basePath += '/' + groupBy;
        fileName = `utm-activity-metrics-${range}-${groupBy}.csv`;
      } else {
        fileName = `utm-activity-metrics-${range}-Source.csv`;
      }
      var url = endpoints.root + basePath + Query.get();
      x.open("GET", url, true);
      x.setRequestHeader('x-account-id', tenantId);
      x.setRequestHeader('x-app-id', tenantId);
      if (AuthBase.idToken) x.setRequestHeader('Authorization', 'Bearer ' + AuthBase.idToken); // metrics routes need a signed-in caller (2026-10-11)
      x.responseType = 'blob';
      x.onload = function (e) {
        download(x.response, fileName, "text/csv");
      };
      x.send();
    });
    _defineProperty(this, "convertToChartData", data => {
      var chart = [];
      var header = ['Label', 'Count'];
      chart.push(header);
      data.forEach(obj => {
        chart.push([obj.title, obj.count]);
      });
      if (data.length < 1) {
        chart.push(['N/A', 0]);
      }
      return chart;
    });
  }
  componentDidMount() {
    console.log('utm mounted');
    publishSearch('Activity');
    //publishEvent('reset-search', {});
  }
  render() {
    var data = this.props.data;
    var metrics = data.activityMetrics;
    var activity = data.activity.items;
    var range = this.props.params.range;
    var groupBy = this.props.params.groupBy;
    var selection = 'All Time';
    var refreshUrl = '/Activity';
    var baseUrl = '/Activity';
    var utmBaseUrl = '/Activity/Utm';
    var utmRefreshUrl = '/Activity';
    if (range) {
      selection = rangeLabel(range);
      baseUrl += '/' + range;
      utmBaseUrl += '/' + range;
    }
    if (groupBy) {
      utmBaseUrl += '/' + groupBy;
    } else {
      groupBy = 'All';
    }
    var conversions = metrics.conversionMetrics;
    var engagements = metrics.engagementMetrics;
    var chart1Data = this.convertToChartData(metrics.conversionList);
    var chart2Data = this.convertToChartData(metrics.engagementList);
    var chart1Options = {
      colors: ['#2196F3']
    };
    var chart2Options = {
      colors: ['#2ED47A']
    };
    var accountModel = account.get();
    var campaign = accountModel.showCampaigns;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlexboxContainer, {
      cls: "activity"
    }, /*#__PURE__*/React.createElement(Container, {
      title: "Conversions",
      css: "stacked order-3"
    }, /*#__PURE__*/React.createElement(KpiStrip, null, /*#__PURE__*/React.createElement(Kpi, {
      label: "Total",
      value: currencyFormat(conversions.total, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Users",
      value: currencyFormat(conversions.users, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Sessions",
      value: currencyFormat(conversions.sessions, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Value",
      value: currencyFormat(conversions.value)
    }))), /*#__PURE__*/React.createElement(ActivityContainer, {
      cls: "stacked order-1"
    }, /*#__PURE__*/React.createElement(ActivityHeader, {
      title: "Interactions",
      selection: selection,
      id: "conversions",
      onSelected: this.onSelected
    }), /*#__PURE__*/React.createElement(ActivityData, null, /*#__PURE__*/React.createElement(KpiStrip, null, /*#__PURE__*/React.createElement(Kpi, {
      label: "Total",
      value: currencyFormat(engagements.total, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Users",
      value: currencyFormat(engagements.users, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Sessions",
      value: currencyFormat(engagements.sessions, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Value",
      value: currencyFormat(engagements.value)
    })))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "order-4"
    }, /*#__PURE__*/React.createElement(Chart, {
      width: '100%',
      height: '400px',
      chartType: "ColumnChart",
      loader: /*#__PURE__*/React.createElement(ChartLoader, null),
      data: chart1Data,
      options: chart1Options,
      rootProps: {
        'data-id': '1'
      }
    })), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "order-2"
    }, /*#__PURE__*/React.createElement(Chart, {
      width: '100%',
      height: '400px',
      chartType: "ColumnChart",
      loader: /*#__PURE__*/React.createElement(ChartLoader, null),
      data: chart2Data,
      options: chart2Options,
      rootProps: {
        'data-id': '2'
      }
    }))), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "heading-label"
    }, "Engagements/Conversions")), /*#__PURE__*/React.createElement("button", {
      className: "ui-button primary small icon",
      onClick: this.onExport
    }, "Export ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "arrow_right"))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(ActivityGrid, {
      refreshUrl: refreshUrl,
      baseUrl: baseUrl,
      data: activity,
      linkToDetail: true,
      range: range,
      pagination: this.props.pagination,
      onPageRequest: this.onPageRequest,
      campaign: campaign
    })), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UtmFilter, {
      id: "utm-filter",
      selection: groupBy,
      onSelected: this.onUtmFilterSelected
    })), /*#__PURE__*/React.createElement("button", {
      className: "ui-button secondary small icon",
      onClick: this.onUtmExport
    }, "Export ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "arrow_right"))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(UtmActivityGrid, {
      refreshUrl: utmRefreshUrl,
      baseUrl: utmBaseUrl,
      data: this.props.utmData,
      range: range,
      pagination: this.props.utmPagination,
      onPageRequest: this.onUtmPageRequest
    })));
  }
}
export class ActivityUtmViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
  }
  get api() {
    var api = '/metrics/data';
    var range = this.range;
    api += '/' + range;
    return api;
  }
  get baseUrl() {
    var baseUrl = '/Activity';
    var range = this.range;
    baseUrl += '/' + range;
    return baseUrl;
  }
  get utmApi() {
    let query = this.queryParams;
    var api = '/metrics/utm';
    var range = this.range;
    api += '/' + range;
    var groupBy = this.props.params.groupBy;
    if (groupBy) {
      api += '/' + groupBy;
    }
    let $where = query.get('$where');
    let $params = query.get('$params');
    $where = Query.WHERE($where);
    $params = Query.PARAMS($params);
    if ($where && $params) {
      api += '?$where=' + $where + '&$params=' + $params;
    }
    return api;
  }
  get utmBaseUrl() {
    var baseUrl = '/Activity/Utm';
    var range = this.range;
    baseUrl += '/' + range;
    var groupBy = this.props.params.groupBy;
    if (groupBy) {
      baseUrl += '/' + groupBy;
    }
    return baseUrl;
  }
  get range() {
    var range = this.props.params.range;
    if (!range) range = 'this_month';
    return range;
  }
  async fetchData() {
    let query = this.queryParams;
    let page = 1;
    let utmPage = this.page;
    var api = this.api;
    var utmApi = this.utmApi;
    var baseUrl = this.baseUrl;
    var utmBaseUrl = this.utmBaseUrl;
    var Service = ServiceFactory.getType(api);
    var service = new Service();
    var UtmService = ServiceFactory.getType(utmApi);
    var utmService = new UtmService();
    try {
      let data = await service.paginate({
        baseUrl: baseUrl,
        rawUrl: location.href,
        page: page,
        pageSize: 10
      }).getAsync();
      console.log(data);
      let utmData = await utmService.paginate({
        baseUrl: utmBaseUrl,
        rawUrl: location.href,
        page: utmPage,
        pageSize: 10
      }).orderBy(query.get('$orderBy')).orderByDesc(query.get('$orderByDesc')).getAsync();
      console.log(utmData);
      this.data = data.items;
      this.pagination = data.pagination;
      this.utmData = utmData.items;
      this.utmPagination = utmData.pagination;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        pagination: this.pagination,
        utmData: this.utmData,
        utmPagination: this.utmPagination,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  ActivityUtmViewComponent
};